import React from "react"
import { object } from "prop-types"
import { EventWizardStyle } from './style'

const EventWizardSteps = (props) => {
	return (
		<div style={EventWizardStyle}>
			{props.children}
		</div>
	)
}
EventWizardSteps.propTypes = {
  children: object,
}
export default EventWizardSteps



// WEBPACK FOOTER //
// ./src/containers/event/EventWizard/Wizard/steps.js